import {setAppIsMobile, setIsSmallScreen} from "../store/app";

export default class Display {

	static appMobileWidth = 500;
	static appSmallHeight = 700;

	static startService() {
		window.addEventListener('resize', Display.windowOnResize );
		Display.windowOnResize();
	}

	static windowOnResize() {
		setAppIsMobile(document.documentElement.clientWidth<=Display.appMobileWidth);
		setIsSmallScreen(window.innerHeight<Display.appSmallHeight);
	}
}
